export enum ThemesEnum {
  qiwi = 'qiwi',
  figs = 'figs',
  banana = 'banana',
  chilli = 'chilli',
  potato = 'potato'
}

export type Themes = ThemesEnum.qiwi | ThemesEnum.figs | ThemesEnum.banana | ThemesEnum.chilli | ThemesEnum.potato
